module.exports = __webpack_public_path__ + "static/media/Todd.bf739d85.jpg";